import { render, staticRenderFns } from "./DisplayWaiting.vue?vue&type=template&id=9600c09a&scoped=true&"
import script from "./DisplayWaiting.vue?vue&type=script&lang=js&"
export * from "./DisplayWaiting.vue?vue&type=script&lang=js&"
import style0 from "./DisplayWaiting.vue?vue&type=style&index=0&id=9600c09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9600c09a",
  null
  
)

export default component.exports